import { capitalize } from "@s-libs/micro-dash";

import AUTH_PROVIDER_NAME_TRANSFORMATIONS, {
  type AuthProviderOption,
} from "@/constants/AUTH_PROVIDER_NAME_TRANSFORMATIONS";

const getAuthProviderName = (
  provider?: AuthProviderOption,
  classroomSync = false,
) => {
  if (!provider) return "";
  if (classroomSync && provider === "google-oauth2") return "Google Classroom";
  return AUTH_PROVIDER_NAME_TRANSFORMATIONS[provider] || capitalize(provider);
};

export default getAuthProviderName;
